const getBackendURL = (env) => {
  switch (env) {
    case 'development':
      return 'http://localhost:5000/api';
    case 'staging':
      return 'https://staging-erm.aumyaa.com/api';
    case 'production':
      return 'https://erm.aumyaa.com/api';
    default:
      return 'http://localhost:5000/api';
  }
};

const getFlaskHelperURL = (env) => {
  switch (env) {
    case 'development':
      return 'http://localhost:5001';
    case 'staging':
      return 'https://staging-erm.aumyaa.com/helper';
    case 'production':
      return 'https://erm.aumyaa.com/helper';
    default:
      return 'http://localhost:5001';
  }
};

export const BACKEND_URL = getBackendURL(process.env.REACT_APP_ENV);
export const FLASK_HELPER_URL = getFlaskHelperURL(process.env.REACT_APP_ENV);
